import React, { useState, useRef } from "react";

import {
  CCol,
  CRow,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInput,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody
} from "@coreui/react";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Label } from "reactstrap";

// import StatisticsAccessFilter from "../../../components/Statistics/StatisticsAccess/StatisticsAccessFilter";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  arrayToCSV,
  elementToPDF,
  arrayToXLSX,
  arrayToXLS
} from "../../../../utils/export";
import Loading from "../../../Loading";
import ChartUsers from "../ChartUsers";
import ChartWhoAccess from "../ChartWhoAccess";
import ModalContentDetails from "../ModalContentDetails";
import StatisticsAccessFilter from "../StatisticsAccessFilter";

import "./styles.css";
// import { set } from "core-js/library/fn/dict";

const PageAccess = ({ applications, user, printStatistic }) => {
  const token = useSelector(state => state.user.token);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [roleId, setRoleId] = useState(0);

  const [tableGroupSelected, setTableGroupSelected] = useState([]);
  const [tableRegionSelected, setTableRegionSelected] = useState([]);
  const [tableSchoolSelected, setTableSchoolSelected] = useState([]);
  const [tableRoomSelected, setTableRoomSelected] = useState([]);

  const [initialDay, setInitialDay] = useState();
  const [finalDay, setFinalDay] = useState();
  const [initialMonth, setInitialMonth] = useState();
  const [finalMonth, setFinalMonth] = useState();

  const [typePeriod, setTypePeriod] = useState("day");

  const [pageLoading, setPageLoading] = useState(false);

  const [data, setData] = useState(null);
  const [modal, setModal] = useState(false);
  const [contentDetails, setContentDetails] = useState(false);

  const table = useRef(null);

  const changeFilter = selected => {
    setRoomId(selected.roomId);
    setRoleId(selected.roleId);
    setGroupId(selected.groupId);
    setRegionId(selected.regionId);
    setSchoolId(selected.schoolId);
  };

  const onFilter = async () => {
    if (!groupId) {
      toastr.warning("Atenção", "Escolha um grupo");
      return;
    }

    if (typePeriod === "day" && (!initialDay || !finalDay)) {
      toastr.warning("Atenção", "Preencha o período");
      return;
    }

    if (typePeriod === "month" && (!initialMonth || !finalMonth)) {
      toastr.warning("Atenção", "Preencha o período");
      return;
    }

    setPageLoading(true);

    try {
      // aqui
      const res = await axios.get(`${URL.api}statistics/management`, {
        params: {
          group_id: groupId,
          region_id: regionId,
          school_id: schoolId,
          room_id: roomId,
          role_id: roleId,
          period: typePeriod,
          start: typePeriod === "day" ? initialDay : initialMonth,
          end: typePeriod === "day" ? finalDay : finalMonth
        },
        headers: { authorization: `Bearer ${token}` }
      });
      res.data.data.offlineAccessPizzaChart = {
        "Acessos Offline":
          Object.keys(res.data.data.offline_accesses).length > 0
            ? Object.values(res.data.data.offline_accesses).reduce(
                (acumulator, value) => acumulator + value
              )
            : 0,
        Acessos:
          Object.keys(res.data.data.accesses).length > 0
            ? Object.values(res.data.data.accesses).reduce(
                (acumulator, value) => acumulator + value
              )
            : 0
      };
      setData(res.data.data);
      setPageLoading(false);
    } catch (err) {
      toastr.error("Falha", "Não foi possível obter as estatísticas");
      setPageLoading(false);
    }
  };

  const onTypePeriodDay = () => {
    setTypePeriod("day");
  };

  const onTypePeriodMonth = () => {
    setTypePeriod("month");
  };

  const handleInitialDay = event => {
    setInitialDay(event.target.value);
  };

  const handleFinalDay = event => {
    setFinalDay(event.target.value);
  };

  const handleInitialMonth = event => {
    setInitialMonth(event.target.value);
  };

  const handleFinalMonth = event => {
    setFinalMonth(event.target.value);
  };

  const handleGroupSelected = id => {
    let index = tableGroupSelected.indexOf(id);
    if (index !== -1) {
      setTableGroupSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableGroupSelected(newArray => [...newArray, id]);
    }
  };

  const handleRegionSelected = id => {
    let index = tableRegionSelected.indexOf(id);
    if (index !== -1) {
      setTableRegionSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableRegionSelected(newArray => [...newArray, id]);
    }
  };

  const handleSchoolSelected = id => {
    let index = tableSchoolSelected.indexOf(id);
    if (index !== -1) {
      setTableSchoolSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableSchoolSelected(newArray => [...newArray, id]);
    }
  };

  const handleRoomSelected = id => {
    let index = tableRoomSelected.indexOf(id);
    if (index !== -1) {
      setTableRoomSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableRoomSelected(newArray => [...newArray, id]);
    }
  };

  const showModal = (e, group = 0, region = 0, school = 0, room = 0) => {
    e.stopPropagation();

    setContentDetails({
      group_id: groupId || group,
      region_id: regionId || region,
      school_id: schoolId || school,
      room_id: roomId || room,
      role_id: roleId,
      period: typePeriod,
      start: typePeriod === "day" ? initialDay : initialMonth,
      end: typePeriod === "day" ? finalDay : finalMonth
    });

    setModal(true);
  };

  const getArrayCSV = data => {
    const header = [
      "tipo_de_unidade",
      "nome",
      "quantidade_usuarios",
      "quantidade_acessantes",
      "percentual_acessantes",
      "quantidade_acessos",
      "quantidade_conteudos",
      "quantidade_conteudos_acessados",
      "percentual_conteudos_acessados",
      "quantidade_acessos_conteudos"
    ];

    const arr = [header];

    data.forEach(group => {
      arr.push([
        "grupo",
        group.name,
        group.users,
        group.total_accessors,
        group.users_accessors,
        group.total_accesses,
        group.contents,
        group.accessed_contents,
        group.contents_accessed_contents,
        group.accesses_content
      ]);

      group.regions.forEach(region => {
        arr.push([
          "regional",
          region.name,
          region.users,
          region.total_accessors,
          region.users_accessors,
          region.total_accesses,
          region.contents,
          region.accessed_contents,
          region.contents_accessed_contents,
          region.accesses_content
        ]);

        region.schools.forEach(school => {
          arr.push([
            "escola",
            school.name,
            school.users,
            school.total_accessors,
            school.users_accessors,
            school.total_accesses,
            school.contents,
            school.accessed_contents,
            school.contents_accessed_contents,
            school.accesses_content
          ]);

          school.rooms.forEach(room => {
            arr.push([
              "turma",
              room.name,
              room.users,
              room.total_accessors,
              room.users_accessors,
              room.total_accesses,
              room.contents,
              room.accessed_contents,
              room.contents_accessed_contents,
              room.accesses_content
            ]);
          });
        });
      });
    });

    return arr;
  };

  return (
    <>
      {modal && (
        <ModalContentDetails
          show
          filter={contentDetails}
          onClose={() => setModal(false)}
        />
      )}
      <div className="d-flex flex-column align-items-left">
        <CCard>
          <CCardBody>
            <CRow className="mb-0">
              <CCol style={{ maxWidth: "100%" }}>
                <StatisticsAccessFilter onChange={changeFilter} />
              </CCol>
            </CRow>
            <div className="d-flex w-100">
              <div className="flex-column mr-3">
                <Label className="d-block w-100 text-ellipsis">
                  Tipo de gráfico
                </Label>
                <CButtonGroup>
                  <CButton
                    color={typePeriod === "day" ? "primary" : "secondary"}
                    onClick={onTypePeriodDay}
                    className="shadow-none"
                  >
                    Diário
                  </CButton>
                  <CButton
                    color={typePeriod === "month" ? "primary" : "secondary"}
                    onClick={onTypePeriodMonth}
                    className="shadow-none"
                  >
                    Mensal
                  </CButton>
                </CButtonGroup>
              </div>
              <div className="flex-column w-100 flex-nowrap">
                <Label className="d-block w-100 text-ellipsis">Período</Label>
                <div className="d-flex w-100 align-items-center">
                  <div className="flex-1 d-flex align-items-center">
                    <CFormGroup className="m-0">
                      <CInputGroup className="input-prepend">
                        {typePeriod === "day" ? (
                          <>
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-clock-o"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              type="date"
                              onChange={handleInitialDay}
                              value={initialDay}
                            ></CInput>
                          </>
                        ) : (
                          <>
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-clock-o"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              type="month"
                              onChange={handleInitialMonth}
                              value={initialMonth}
                            ></CInput>
                          </>
                        )}
                      </CInputGroup>
                    </CFormGroup>
                    <div style={{ textAlign: "center" }} className="mx-3">
                      até
                    </div>
                    <CFormGroup className="m-0">
                      <CInputGroup className="input-prepend">
                        {typePeriod === "day" ? (
                          <>
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-clock-o"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              type="date"
                              onChange={handleFinalDay}
                              value={finalDay}
                            ></CInput>
                          </>
                        ) : (
                          <>
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-clock-o"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              type="month"
                              onChange={handleFinalMonth}
                              value={finalMonth}
                            ></CInput>
                          </>
                        )}
                      </CInputGroup>
                    </CFormGroup>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex w-100 flex-column align-items-end mt-4">
              <CButton
                color="primary"
                className="ml-2 d-flex flex-nowrap align-items-center justify-content-center"
                onClick={onFilter}
              >
                <AiOutlineSearch className="mr-1" />
                Procurar
              </CButton>
            </div>
          </CCardBody>
        </CCard>
        {pageLoading ? (
          <div className="w-100 p-5 text-muted justify-content-center d-flex text-center">
            <Loading />
          </div>
        ) : !data ? (
          <div className="w-100 p-5 text-muted justify-content-center d-flex text-center">
            Preencha os filtros para obter as estatísticas da plataforma
          </div>
        ) : (
          <div className="w-100">
            <div className="d-flex w-100 justify-content-end">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToCSV(getArrayCSV(data.units), "Gestão.csv")
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLSX(getArrayCSV(data.units), "Gestão.xlsx")
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLSX
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLS(getArrayCSV(data.units), "Gestão.xls")
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLS
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() => elementToPDF("toPrint", "Gestão.pdf")}
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
              </CButton>
            </div>
            <div className="w-100" id="toPrint">
              <CRow style={{ marginTop: "15px" }}>
                <CCol xs={6}>
                  <div>
                    <h4>Gráfico de Acessantes</h4>
                  </div>
                  <div>
                    <ChartWhoAccess
                      period={data.period}
                      data={data.total_accessors}
                      start={data.start}
                      end={data.end}
                    />
                  </div>
                </CCol>
                <CCol xs={6}>
                  <div>
                    <h4>Gráfico de Acessos</h4>
                  </div>
                  <div>
                    <ChartWhoAccess
                      period={data.period}
                      data={data.total_accesses}
                      start={data.start}
                      end={data.end}
                    />
                  </div>
                </CCol>
              </CRow>
              <CRow style={{ marginTop: "35px" }}>
                <CCol xs={6}>
                  <div>
                    <h4>Gráfico de Usuários (Geral)</h4>
                  </div>
                  <div>
                    <ChartUsers data={data.accessorsRoles} />
                  </div>
                </CCol>
                <CCol xs={6}>
                  <div>
                    <h4>Gráfico de Acesso aos Conteúdos Multimídia</h4>
                  </div>
                  <div>
                    <ChartWhoAccess
                      period={data.period}
                      data={data.accessesContent}
                      start={data.start}
                      end={data.end}
                    />
                  </div>
                </CCol>
              </CRow>
              <table style={{ marginTop: "80px" }} className="w-100">
                <thead>
                  <tr>
                    <th>Unidade</th>
                    <th>
                      Quant. <br></br>Usuários
                    </th>
                    <th>
                      Quant. <br></br>Acessantes
                    </th>
                    <th>
                      Percent. <br></br>Acessantes
                    </th>
                    <th>
                      Quant. <br></br>Acessos
                    </th>
                    <th>
                      Quant. <br></br>Conteúdos
                    </th>
                    <th>
                      Quant. <br></br>Conteúdos Acessados
                    </th>
                    <th>
                      Percent. <br></br>Conteúdos Acessados
                    </th>
                    <th>
                      Quant. <br></br>Acessos aos Conteúdos
                    </th>
                  </tr>
                </thead>
                <tbody id="tableBody" ref={table}>
                  {data.units.map(group => (
                    <>
                      <tr
                        className="rowTable"
                        onClick={() => handleGroupSelected(group.id)}
                      >
                        <td>{group.name}</td>
                        <td>{group.users}</td>
                        <td>{group.accessors}</td>
                        <td>{group.users_accessors.toFixed(2)}%</td>
                        <td>{group.accesses}</td>
                        <td>{group.contents}</td>
                        <td className="d-flex justify-content-between align-items-center">
                          {group.accessed_contents}
                          <i
                            className="fa fa-calendar cursor"
                            onClick={e => showModal(e, group.id)}
                          ></i>
                        </td>
                        <td>{group.contents_accessed_contents.toFixed(2)}%</td>
                        <td>{group.accesses_content}</td>
                      </tr>
                      {tableGroupSelected.includes(group.id) &&
                        group.regions.map(region => (
                          <>
                            <tr
                              className="rowTable"
                              onClick={() => handleRegionSelected(region.id)}
                            >
                              <td style={{ paddingLeft: "20px" }}>
                                {region.name}
                              </td>
                              <td>{region.users}</td>
                              <td>{region.total_accessors}</td>
                              <td>{region.users_accessors.toFixed(2)}%</td>
                              <td>{region.total_accesses}</td>
                              <td>{region.contents}</td>
                              <td className="d-flex justify-content-between align-items-center">
                                {region.accessed_contents}
                                <i
                                  className="fa fa-calendar cursor"
                                  onClick={e =>
                                    showModal(e, group.id, region.id)
                                  }
                                ></i>
                              </td>
                              <td>
                                {region.contents_accessed_contents.toFixed(2)}%
                              </td>
                              <td>{region.accesses_content}</td>
                            </tr>
                            {tableRegionSelected.includes(region.id) &&
                              region.schools.map(school => (
                                <>
                                  <tr
                                    className="rowTable"
                                    onClick={() =>
                                      handleSchoolSelected(school.id)
                                    }
                                  >
                                    <td style={{ paddingLeft: "40px" }}>
                                      {school.name}
                                    </td>
                                    <td>{school.users}</td>
                                    <td>{school.total_accessors}</td>
                                    <td>
                                      {school.users_accessors.toFixed(2)}%
                                    </td>
                                    <td>{school.total_accesses}</td>
                                    <td>{school.contents}</td>
                                    <td className="d-flex justify-content-between align-items-center">
                                      {school.accessed_contents}
                                      <i
                                        className="fa fa-calendar cursor"
                                        onClick={e =>
                                          showModal(
                                            e,
                                            group.id,
                                            region.id,
                                            school.id
                                          )
                                        }
                                      ></i>
                                    </td>
                                    <td>
                                      {school.contents_accessed_contents.toFixed(
                                        2
                                      )}
                                      %
                                    </td>
                                    <td>{school.accesses_content}</td>
                                  </tr>
                                  {tableSchoolSelected.includes(school.id) &&
                                    school.rooms.map(room => (
                                      <tr
                                        className="rowTable"
                                        onClick={() =>
                                          handleRoomSelected(room.id)
                                        }
                                      >
                                        <td style={{ paddingLeft: "60px" }}>
                                          {room.name}
                                        </td>
                                        <td>{room.users}</td>
                                        <td>{room.total_accessors}</td>
                                        <td>
                                          {room.users_accessors.toFixed(2)}%
                                        </td>
                                        <td>{room.total_accesses}</td>
                                        <td>{room.contents}</td>
                                        <td className="d-flex justify-content-between align-items-center">
                                          {room.accessed_contents}
                                          <i
                                            className="fa fa-calendar cursor"
                                            onClick={e =>
                                              showModal(
                                                e,
                                                group.id,
                                                region.id,
                                                school.id,
                                                room.id
                                              )
                                            }
                                          ></i>
                                        </td>
                                        <td>
                                          {room.contents_accessed_contents.toFixed(
                                            2
                                          )}
                                          %
                                        </td>
                                        <td>{room.accesses_content}</td>
                                      </tr>
                                    ))}
                                </>
                              ))}
                          </>
                        ))}
                    </>
                  ))}
                </tbody>
              </table>
              <CRow style={{ marginTop: "35px" }}>
                <CCol xs={6}>
                  <div>
                    <h4>Gráfico de Acesso x Offline</h4>
                  </div>
                  <div>
                    <ChartUsers data={data.offlineAccessPizzaChart} />
                  </div>
                </CCol>
                <CCol xs={6}>
                  <div>
                    <h4>Gráfico de Acesso Offline</h4>
                  </div>
                  <div>
                    <ChartWhoAccess
                      period={data.period}
                      data={data.offline_accesses}
                      start={data.start}
                      end={data.end}
                    />
                  </div>
                </CCol>
              </CRow>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PageAccess;
